export const tours = [
  {
    id: "santorini-escape",
    title: "Santorini Island Escape",
    destination: "Santorini, Greece",
    region: "Europe",
    duration: "7 Days / 6 Nights",
    price: 2499,
    rating: 4.9,
    reviews: 128,
    image: "https://images.unsplash.com/photo-1612369218304-cf5ee316c473?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1672622851784-0dbd3df4c088?w=1920&q=80",
    description: "Experience the magic of Santorini's iconic white-washed buildings, breathtaking sunsets, and crystal-clear Aegean waters. This carefully curated tour includes luxury accommodations, private wine tastings, and guided exploration of ancient ruins.",
    highlights: [
      "Sunset cruise around the caldera",
      "Private wine tasting at Santo Wines",
      "Guided tour of ancient Akrotiri",
      "Beach day at Red Beach & Perissa",
      "Traditional Greek cooking class"
    ],
    included: [
      "6 nights luxury hotel accommodation",
      "Daily breakfast & 3 dinners",
      "All transfers & transportation",
      "English-speaking guide",
      "Entrance fees to all attractions"
    ],
    itinerary: [
      { day: 1, title: "Arrival in Santorini", description: "Airport transfer, hotel check-in, welcome dinner at a seaside taverna" },
      { day: 2, title: "Oia & Caldera Views", description: "Guided walking tour of Oia, iconic blue-domed churches, caldera viewpoints" },
      { day: 3, title: "Wine & History", description: "Wine tasting at Santo Wines, ancient Akrotiri archaeological site" },
      { day: 4, title: "Beach Day", description: "Red Beach, Perissa Black Beach, seaside lunch" },
      { day: 5, title: "Sunset Cruise", description: "Full-day catamaran cruise, swimming in hot springs, BBQ dinner" },
      { day: 6, title: "Cooking & Culture", description: "Greek cooking class, free afternoon exploring Fira" },
      { day: 7, title: "Departure", description: "Farewell breakfast, airport transfer" }
    ]
  },
  {
    id: "parisian-romance",
    title: "Parisian Romance",
    destination: "Paris, France",
    region: "Europe",
    duration: "5 Days / 4 Nights",
    price: 1899,
    rating: 4.8,
    reviews: 96,
    image: "https://images.unsplash.com/photo-1431274172761-fca41d930114?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1570097703229-b195d6dd291f?w=1920&q=80",
    description: "Discover the City of Light with our exclusive Parisian Romance tour. From the Eiffel Tower to hidden Montmartre streets, enjoy world-class cuisine, art galleries, and the timeless charm that makes Paris unforgettable.",
    highlights: [
      "Skip-the-line Eiffel Tower visit",
      "Private Louvre Museum tour",
      "Seine River dinner cruise",
      "Montmartre walking tour",
      "French pastry workshop"
    ],
    included: [
      "4 nights boutique hotel in Le Marais",
      "Daily breakfast & 2 gourmet dinners",
      "Metro pass for unlimited travel",
      "Expert local guide",
      "All museum entrance tickets"
    ],
    itinerary: [
      { day: 1, title: "Bonjour Paris", description: "Airport transfer, check-in, evening Seine River walk" },
      { day: 2, title: "Icons of Paris", description: "Eiffel Tower, Trocadéro, Champs-Élysées, Arc de Triomphe" },
      { day: 3, title: "Art & Culture", description: "Louvre Museum, Tuileries Garden, Musée d'Orsay" },
      { day: 4, title: "Montmartre & Beyond", description: "Sacré-Cœur, Montmartre, pastry workshop, dinner cruise" },
      { day: 5, title: "Au Revoir", description: "Morning at leisure, airport transfer" }
    ]
  },
  {
    id: "bali-paradise",
    title: "Bali Tropical Paradise",
    destination: "Bali, Indonesia",
    region: "Asia",
    duration: "10 Days / 9 Nights",
    price: 2199,
    rating: 4.9,
    reviews: 154,
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1920&q=80",
    description: "Immerse yourself in Bali's enchanting blend of ancient temples, terraced rice paddies, pristine beaches, and vibrant culture. This comprehensive tour covers the island's most breathtaking locations with luxury at every turn.",
    highlights: [
      "Ubud rice terrace trek",
      "Traditional Balinese spa day",
      "Sunrise at Mount Batur",
      "Uluwatu Temple sunset ceremony",
      "Snorkeling in Nusa Penida"
    ],
    included: [
      "9 nights luxury villa & resort stay",
      "Daily breakfast & 4 dinners",
      "Private driver throughout",
      "Balinese guide",
      "All activity fees & entrance tickets"
    ],
    itinerary: [
      { day: 1, title: "Welcome to Bali", description: "Arrival, villa check-in in Seminyak, welcome dinner" },
      { day: 2, title: "Seminyak & Canggu", description: "Beach clubs, rice paddies, sunset at Tanah Lot" },
      { day: 3, title: "Transfer to Ubud", description: "Tegallalang Rice Terraces, Monkey Forest" },
      { day: 4, title: "Mount Batur Sunrise", description: "Pre-dawn trek, breakfast at summit, hot springs" },
      { day: 5, title: "Ubud Culture", description: "Art galleries, cooking class, traditional dance show" },
      { day: 6, title: "Nusa Penida", description: "Boat to Nusa Penida, snorkeling, Kelingking Beach" },
      { day: 7, title: "Nusa Penida Day 2", description: "Crystal Bay, Angel's Billabong, return to mainland" },
      { day: 8, title: "South Bali", description: "Uluwatu Temple, Kecak fire dance, cliff-top dinner" },
      { day: 9, title: "Spa & Leisure", description: "Full spa day, shopping, farewell dinner" },
      { day: 10, title: "Departure", description: "Last morning swim, airport transfer" }
    ]
  },
  {
    id: "maldives-retreat",
    title: "Maldives Luxury Retreat",
    destination: "Maldives",
    region: "Indian Ocean",
    duration: "6 Days / 5 Nights",
    price: 3499,
    rating: 5.0,
    reviews: 87,
    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=1920&q=80",
    description: "Escape to the ultimate tropical paradise. Crystal-clear turquoise waters, overwater villas, and world-class diving make the Maldives the perfect luxury retreat. Experience unparalleled serenity and natural beauty.",
    highlights: [
      "Overwater villa with private pool",
      "Sunset dolphin cruise",
      "Scuba diving with manta rays",
      "Private beach dinner under stars",
      "Underwater restaurant experience"
    ],
    included: [
      "5 nights overwater villa",
      "Full board (all meals included)",
      "Speedboat transfers",
      "2 diving sessions",
      "Sunset cruise & beach dinner"
    ],
    itinerary: [
      { day: 1, title: "Island Arrival", description: "Speedboat transfer, villa check-in, welcome cocktails" },
      { day: 2, title: "Ocean Adventures", description: "Morning snorkel safari, afternoon spa, sunset cruise" },
      { day: 3, title: "Deep Blue", description: "Scuba diving with manta rays, underwater restaurant lunch" },
      { day: 4, title: "Island Hopping", description: "Local island visit, dolphin watching, sandbank picnic" },
      { day: 5, title: "Ultimate Relaxation", description: "Overwater spa, yoga session, private beach dinner" },
      { day: 6, title: "Farewell Paradise", description: "Sunrise swim, breakfast, speedboat departure" }
    ]
  },
  {
    id: "dubai-grand",
    title: "Dubai Grand Tour",
    destination: "Dubai, UAE",
    region: "Middle East",
    duration: "8 Days / 7 Nights",
    price: 2799,
    rating: 4.8,
    reviews: 112,
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&q=80",
    heroImage: "https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8?w=1920&q=80",
    description: "Experience the dazzling city of Dubai where ultramodern architecture meets ancient Arabian heritage. From the world's tallest building to desert safaris, this tour showcases the best of this spectacular metropolis.",
    highlights: [
      "Burj Khalifa At The Top experience",
      "Desert safari with BBQ dinner",
      "Dhow cruise on Dubai Creek",
      "Dubai Mall & Aquarium",
      "Abu Dhabi day trip"
    ],
    included: [
      "7 nights 5-star hotel in Downtown Dubai",
      "Daily breakfast & 3 dinners",
      "Private transfers throughout",
      "English-speaking guide",
      "All entrance fees included"
    ],
    itinerary: [
      { day: 1, title: "Welcome to Dubai", description: "Airport VIP transfer, hotel check-in, evening fountain show" },
      { day: 2, title: "Modern Marvels", description: "Burj Khalifa, Dubai Mall, Dubai Aquarium" },
      { day: 3, title: "Old Dubai", description: "Gold Souk, Spice Souk, abra ride, Dubai Museum" },
      { day: 4, title: "Desert Adventure", description: "Dune bashing, camel ride, BBQ dinner under the stars" },
      { day: 5, title: "Palm & Marina", description: "Palm Jumeirah, Atlantis, Dubai Marina, beach day" },
      { day: 6, title: "Abu Dhabi Excursion", description: "Sheikh Zayed Mosque, Louvre Abu Dhabi" },
      { day: 7, title: "Luxury & Leisure", description: "Spa day, shopping at Mall of Emirates, Dhow cruise dinner" },
      { day: 8, title: "Departure", description: "Last breakfast, airport transfer" }
    ]
  },
  {
    id: "swiss-alpine",
    title: "Swiss Alpine Adventure",
    destination: "Switzerland",
    region: "Europe",
    duration: "7 Days / 6 Nights",
    price: 2999,
    rating: 4.9,
    reviews: 73,
    image: "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=1920&q=80",
    description: "Journey through Switzerland's most stunning alpine landscapes. From the peaks of Jungfrau to the shores of Lake Lucerne, experience world-class scenery, charming villages, and the famous Swiss hospitality.",
    highlights: [
      "Jungfraujoch - Top of Europe",
      "Scenic Golden Pass train ride",
      "Lake Lucerne boat cruise",
      "Chocolate & cheese tastings",
      "Interlaken adventure activities"
    ],
    included: [
      "6 nights in Swiss hotels & chalets",
      "Daily breakfast & 2 dinners",
      "Swiss Travel Pass (unlimited trains)",
      "Mountain excursion tickets",
      "Expert mountain guide"
    ],
    itinerary: [
      { day: 1, title: "Arrive in Zurich", description: "Airport transfer, Old Town walk, welcome fondue dinner" },
      { day: 2, title: "Lucerne", description: "Chapel Bridge, Lion Monument, Lake Lucerne boat cruise" },
      { day: 3, title: "Interlaken", description: "Scenic train to Interlaken, paragliding option" },
      { day: 4, title: "Jungfraujoch", description: "Train to Top of Europe, Ice Palace, Sphinx Observatory" },
      { day: 5, title: "Golden Pass Route", description: "Panoramic train, Gruyères cheese factory, chocolate workshop" },
      { day: 6, title: "Zermatt & Matterhorn", description: "Gornergrat railway, Matterhorn views, village exploration" },
      { day: 7, title: "Departure", description: "Morning walk, transfer to Geneva/Zurich airport" }
    ]
  }
];
